import React, {useState} from 'react';
import {NavLink, Route, Routes} from "react-router-dom";
import Oylik from './oylik/index'
import Dekadalik from './dekada/index'
import ContentTop from "../../../components/ContentTop";
function Index(props) {
    const [menu, setMenu] = useState(1)

    return (
        <>
            <ContentTop>
                <ul className="content-top-left in-menu">
                    <li>PTN</li>
                    <li className={menu==1?'active':''}>
                        <NavLink to="/limit/ptn/dekadalik" onClick={()=>setMenu(1)}>Dekadalik</NavLink>
                    </li>
                    <li className={menu==2?'active':''}>
                        <NavLink to="/limit/ptn/oylik" onClick={()=>setMenu(2)}>Oylik</NavLink>
                    </li>
                </ul>
                <ul className="content-top-left">
                    <ul>

                    </ul>
                </ul>
            </ContentTop>

            <div className="tabs-content table-box">
                <div className="tabs-content-item active">
                    <Routes>
                        <Route path="/*" element={
                            <Dekadalik />
                        }/>
                        <Route path="/oylik/*" element={
                            <Oylik />
                        }/>
                        <Route path="/dekadalik/*" element={
                            <Dekadalik />
                        }/>
                    </Routes>
                </div>
            </div>
        </>
    );
}

export default Index;